import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryConfig } from '@src/lib/api'
import {
  CompanyDealerLeadStatisticRequestQueryDTO,
  CompanyDealerLeadStatisticResponseDTO,
  LeadStatisticRequestQueryDTO,
  LeadStatisticResponseDTO
} from '@src/types/leads'
import {
  ActiveCompanyLeadsStatisticResponseDTO,
  ActiveDealerLeadsStatisticResponseDTO,
  CompanyBusyLeadTotalsQueryDTO,
  DealerBusyLeadTotalsQueryDTO,
  StatisticsExportResponseDTO
} from '@src/types/dealers'
import { dtoToUrlParams } from '@utils/url'

export const statisticApi = createApi({
  reducerPath: 'statisticApi',
  baseQuery: baseQueryConfig('/statistic'),
  tagTypes: [],
  endpoints: build => ({
    getMainLeadsStatistic: build.query<
      LeadStatisticResponseDTO,
      LeadStatisticRequestQueryDTO | void
    >({
      query: (dto) => {
        let url = '/main'

        if (dto) {
          url += '?' + new URLSearchParams(dto as Record<string, string>)
        }

        return { url }
      },
    }),
    getCompanyDealerLeadsStatistic: build.query<
      CompanyDealerLeadStatisticResponseDTO,
      CompanyDealerLeadStatisticRequestQueryDTO | void
    >({
      query: (dto) => {
        let url = '/company-dealer-leads'

        if (dto) {
          url += '?' + new URLSearchParams(dto as Record<string, string>)
        }

        return { url }
      },
    }),
    getStatisticDateRange: build.query<{
      min: string | null;
      max: string | null;
    }, void>({
      query: () => ({ url: '/lead/date-range' }),
    }),
    getDealerLeadsStatistic: build.query<{
      all: number;
      month: number;
    }, void>({
      query: () => ({
        url: '/dealer-leads-counts'
      })
    }),
    activeDealerLeadsStatistic: build.query<
      ActiveDealerLeadsStatisticResponseDTO,
      DealerBusyLeadTotalsQueryDTO | void
    >({
      query: (dto) => {
        let url = '/active-dealer-leads'

        if (dto) {
          url += '?' + dtoToUrlParams(dto)
        }

        return { url }
      }
    }),
    activeCompanyLeadsStatistic: build.query<
      ActiveCompanyLeadsStatisticResponseDTO,
      CompanyBusyLeadTotalsQueryDTO | void
    >({
      query: (dto) => {
        let url = '/active-company-leads'

        if (dto) {
          url += '?' + dtoToUrlParams(dto)
        }

        return { url }
      }
    }),
    statisticsExport: build.query<StatisticsExportResponseDTO, number>({
      query: (year) => ({
        url: `/export/${year}`
      })
    }),
  })
})

export const {
  useGetMainLeadsStatisticQuery,
  useGetCompanyDealerLeadsStatisticQuery,
  useGetDealerLeadsStatisticQuery,
  useGetStatisticDateRangeQuery,
  useActiveDealerLeadsStatisticQuery,
  useActiveCompanyLeadsStatisticQuery,
} = statisticApi